/**
 * Calls `onEnd` when `element`'s CSS animation ends, or after `timeoutMs`
 * if `animationend` never fires.
 *
 * @returns A function that cancels the listener and the timeout without calling `onEnd`.
 */
export function whenAnimationEnds(
  element: HTMLElement | null,
  onEnd: () => void,
  timeoutMs: number,
): () => void {
  let settled = false;
  let timeoutId: number | undefined;

  const finish = () => {
    if (settled) {
      return;
    }

    settled = true;
    window.clearTimeout(timeoutId);
    element?.removeEventListener('animationend', finish);
    onEnd();
  };

  element?.addEventListener('animationend', finish, { once: true });
  timeoutId = window.setTimeout(finish, timeoutMs);

  return () => {
    if (settled) {
      return;
    }

    settled = true;
    window.clearTimeout(timeoutId);
    element?.removeEventListener('animationend', finish);
  };
}
